export default {
  privacyPolicy: 'Privacy Policy',
  footerConsent:
    'By using this chat, you are accepting and consenting to the practices described in our privacy policy.',
};
